
<div id="divCarouselContainer" class="carousel slide" data-ride="carousel" style="margin-top:-4%;">

        <div class="activity-box" *ngIf="dataLoader"><div class="loading-spiner" style="margin-left:10%;"><img alt="loading.." src="assets/img/loadingVer.gif" style="margin-left:35%;" /></div></div>
        <ol class="carousel-indicators">
            <li data-target="#divCarouselContainer" data-slide-to="0" class="active"></li>
            <li data-target="#divCarouselContainer" data-slide-to="1" *ngIf="IsGlobalCarousel"></li>
            <li data-target="#divCarouselContainer" data-slide-to="2" *ngIf="IsGlobalCarousel"></li>
            <li data-target="#divCarouselContainer" data-slide-to="3" *ngIf="IsRegionalCarousel"></li>
            <li data-target="#divCarouselContainer" data-slide-to="4" *ngIf="IsRegionalCarousel"></li>
            <li data-target="#divCarouselContainer" data-slide-to="5" *ngIf="IsRegionalCarousel"></li>
            <!--<li data-target="#divCarouselContainer" data-slide-to="6" *ngIf="IsRegionalCarousel"></li>
             <li data-target="#divCarouselContainer" data-slide-to="6" *ngIf="IsprojectCarousel"></li> -->
            <li data-target="#divCarouselContainer" data-slide-to="6" ></li>
        </ol>    
    
        <div class="carousel-inner" role="">
            <div class="item active" data-interval="100">
                <div class="img-responsive wrapper" style="width:100%;"><app-main-dashboard></app-main-dashboard></div>            
                <div class="carousel-caption" style="background: linear-gradient(deg, #93a5cf 20%, #e4efe9 65%);"></div>
            </div>
            <div class="item" data-interval="150">
                <div class="img-responsive wrapper" style="width:100%;"><app-dashboard></app-dashboard></div>            
                <div class="carousel-caption" style="background: linear-gradient(deg, #93a5cf 20%, #e4efe9 65%);"></div>
            </div>    
            <div class="item" *ngIf="IsGlobalDashboard" data-interval="150">
               <div class="img-responsive wrapper" style="width:100%;"><app-dashboard-voice-admin-global-country></app-dashboard-voice-admin-global-country> </div> 
                <div class="carousel-caption" style="background: linear-gradient(deg, #93a5cf 20%, #e4efe9 65%);"></div>
            </div>
            <div class="item" *ngIf="IsRegionalDashboard"  data-interval="150">
                <div class="img-responsive wrapper" style="width:100%;"><app-dashboard-voice-admin-country></app-dashboard-voice-admin-country> </div>
                <div class="carousel-caption" style="background: linear-gradient(deg, #93a5cf 20%, #e4efe9 65%);">
                </div>
            </div>
            <div class="item" *ngIf="IsRegionalDashboard" data-interval="150">
                <div class="img-responsive wrapper" style="width:100%;"><app-dashboard-voice-admin-trunk-call></app-dashboard-voice-admin-trunk-call> </div>
                <div class="carousel-caption" style="background: linear-gradient(deg, #93a5cf 20%, #e4efe9 65%);">
                </div>
            </div>
            <div class="item" *ngIf="IsRegionalDashboard" data-interval="150">
                <div class="img-responsive wrapper" style="width:100%;"><app-dashboard-voice-admin-gateway></app-dashboard-voice-admin-gateway> </div>
                <div class="carousel-caption" style="background: linear-gradient(deg, #93a5cf 20%, #e4efe9 65%);">
                </div>
            </div>
            <!-- <div class="item" *ngIf="IsRegionalDashboard" data-interval="150">
                <div class="img-responsive wrapper" style="width:100%;"><app-dashboard-voice-admin-cap></app-dashboard-voice-admin-cap> </div>
                <div class="carousel-caption" style="background: linear-gradient(deg, #93a5cf 20%, #e4efe9 65%);">
                </div>
            </div> 
            <div class="item" *ngIf="IsProjectSDashboard" data-interval="150">
                <div class="img-responsive wrapper" style=" width:100%;"><app-dashboard-project-lead></app-dashboard-project-lead> </div>
                <div class="carousel-caption" style="background: linear-gradient(deg, #93a5cf 20%, #e4efe9 65%);">
                </div>
            </div>-->
            <div class="item" data-interval="150">
                <div class="img-responsive wrapper" style=" width:100%;"><app-dashboard-feedback></app-dashboard-feedback></div> 
                <div class="carousel-caption" style="background: linear-gradient(deg, #93a5cf 20%, #e4efe9 65%);"></div>
            </div>
        </div>    
        <a class="left carousel-control" routerLink="#divCarouselContainer" role="button" data-slide="prev">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control" routerLink="#divCarouselContainer" role="button" data-slide="next">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>
    </div> 
    <!-- <script type="text/javascript">
        $('#divCarouselContainer').carousel({
           interval: 1500
        });
        $('#divCarouselContainer').carousel({
           wrap: false
        }).on('slid.bs.carousel', function () {
           curSlide = $('.active');
           if (curSlide.is(':first-child')) {
               $('.left').hide();
               return;
           } else {
               $('.left').show();
           }
           if (curSlide.is(':last-child')) {
               $('.left').hide();
               return;
           } else {
               $('.right').show();
           }
        });
    </script>    -->
    <style type="text/css">
        .right {
            display: none;
        }
    
        .left {
            display: none;
        }
    </style>